export enum AddressType {
    Living = 0,
    Registered = 1,
    Mailing = 2,
    Billing = 3
}